// ============================================================
// 2026-10-01 料金改定の告知期間をJSTで判定する（2026-09-03）。
//
//   rateChangePhase() → 'before' | 'after' | ''
//     'before' : 〜9/30  「10/1より料金改定」の事前告知
//     'after'  : 10/1〜10/15 「10/1より新料金になりました」の事後告知
//     ''       : 表示しない
//
// 端末のタイムゾーンに依存しないよう、UTC時刻に+9時間して年月日を作る。
// 告知記事は 9/1 に一斉配信した公開おしらせ(/notice/:token・ログイン不要)へリンクする。
// ============================================================
export const RATE_CHANGE_NOTICE_PATH = '/notice/8b9cd7c7205811546eb5c87e5db9e640';

export function jstYmd(now = Date.now()) {
  const d = new Date(now + 9 * 60 * 60 * 1000);
  return d.getUTCFullYear() * 10000 + (d.getUTCMonth() + 1) * 100 + d.getUTCDate();
}

export function rateChangePhase(now = Date.now()) {
  const ymd = jstYmd(now);
  if (ymd < 20261001) return 'before';
  if (ymd <= 20261015) return 'after';
  return '';
}
